import { useCallback } from 'react';
import { Link } from 'react-router-dom';
import { Button, Stack, Typography } from '@mui/material';
import Iconify from 'components/atoms/Iconify';
import { RoomHeaderProps } from './interface';

export default function RoomHeader(props: RoomHeaderProps) {
  const { setAddRoomModalShow: setAddUserModalShow } = props;

  const showModal = useCallback(() => {
    setAddUserModalShow(true);
  }, [setAddUserModalShow]);

  return (
    <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
      <Typography variant="h4" gutterBottom>
        Rooms
      </Typography>
      <Button
        variant="contained"
        component={Link}
        to="#"
        startIcon={<Iconify icon="eva:plus-fill" />}
        onClick={showModal}
      >
        New Room
      </Button>
    </Stack>
  );
}
